import { useContext } from 'react';
import Navbar from "./navbar";
import NavbarPublic from "./navbarPublic";
import { AuthContext } from "../context/authContext";

const Header = ({ children }) => {
    const { isAuthenticated } = useContext(AuthContext);

    return (       
        <header className="flex flex-col md:flex-row gap-4 justify-center items-center">
            <div className="flex justify-between items-center p-4 w-full bg-custom-cyan dark:bg-gray-800 transition-colors duration-200">
                {isAuthenticated ? <Navbar /> : <NavbarPublic />}
            </div>
        </header>
    );
};

export default Header;

// quitar 
// <header className="w-full bg-custom-cyan dark:bg-gray-800 shadow-sm transition-colors duration-300 border-yellow-500">
// excedia el ancho de pantalla